{
  "schemaVersion": "1.0",
  "status": "DRAFT_DIRECTIONAL",
  "note": "Directional marketing content. Prices are management targets; public-pricing.json must be generated from Pricing Master at publish.",
  "extensions": [
    {
      "id": "byom",
      "name": "Bring Your Own Module",
      "group": "BUILD",
      "summary": "Create organization-specific capabilities that run inside aviOS.",
      "modules": [
        "intelligence",
        "vault",
        "operate",
        "shop"
      ],
      "roles": [
        "director-of-maintenance",
        "quality-manager",
        "shop-administrator"
      ],
      "orgTypes": [
        "part-135",
        "part-145",
        "integrated-135-145",
        "oem-service"
      ],
      "pricingId": "ext-byom",
      "pricingDisposition": "CONTACT_US"
    },
    {
      "id": "co-build",
      "name": "Co-Build with Ironfleet",
      "group": "BUILD",
      "summary": "Turn unique operational expertise into governed aviation intelligence.",
      "modules": [
        "intelligence",
        "vault",
        "operate",
        "shop"
      ],
      "roles": [
        "director-of-maintenance",
        "accountable-manager"
      ],
      "orgTypes": [
        "part-135",
        "part-145",
        "oem-service",
        "integrated-135-145"
      ],
      "pricingId": "ext-co-build",
      "pricingDisposition": "CONTACT_US"
    },
    {
      "id": "ironfleet-network",
      "name": "Ironfleet Network",
      "group": "BUILD",
      "summary": "Partner AI agents, expertise, data services, and capabilities.",
      "modules": [
        "intelligence",
        "operate",
        "shop"
      ],
      "roles": [
        "parts-coordinator",
        "technician",
        "director-of-maintenance"
      ],
      "orgTypes": [
        "part-135",
        "part-145",
        "independent-mro",
        "management-company"
      ],
      "pricingId": "ext-ironfleet-network",
      "pricingDisposition": "CONTACT_US"
    },
    {
      "id": "integrations",
      "name": "System Integrations",
      "group": "CONNECT",
      "summary": "Connect existing systems while preserving system-of-record authority.",
      "modules": [
        "vault",
        "operate",
        "shop"
      ],
      "roles": [
        "tenant-administrator",
        "shop-administrator"
      ],
      "orgTypes": [
        "part-135",
        "part-145",
        "management-company",
        "integrated-135-145"
      ],
      "pricingId": "ext-integrations",
      "pricingDisposition": "BUDGETARY_RANGE"
    },
    {
      "id": "workflow-extensions",
      "name": "Workflow Extensions",
      "group": "CONNECT",
      "summary": "Configure workflows to your procedures and manuals.",
      "modules": [
        "operate",
        "shop"
      ],
      "roles": [
        "quality-manager",
        "director-of-maintenance"
      ],
      "orgTypes": [
        "part-135",
        "part-145"
      ],
      "pricingId": "ext-workflow-extensions",
      "pricingDisposition": "BUDGETARY_RANGE"
    },
    {
      "id": "data-migration",
      "name": "Data Migration",
      "group": "CONNECT",
      "summary": "Bring historical records and work data into aviOS.",
      "modules": [
        "vault",
        "operate",
        "shop"
      ],
      "roles": [
        "records-specialist",
        "shop-administrator"
      ],
      "orgTypes": [
        "part-135",
        "part-145",
        "management-company"
      ],
      "pricingId": "ext-data-migration",
      "pricingDisposition": "BUDGETARY_RANGE"
    },
    {
      "id": "conformity-review",
      "name": "Aircraft Conformity Review",
      "group": "SERVICE",
      "summary": "Source-linked conformity evidence package.",
      "modules": [
        "operate"
      ],
      "roles": [
        "director-of-maintenance",
        "compliance-manager"
      ],
      "orgTypes": [
        "part-135",
        "management-company"
      ],
      "pricingId": "ext-conformity-review",
      "pricingDisposition": "STARTING_AT"
    },
    {
      "id": "prebuy",
      "name": "Pre-Purchase Due Diligence",
      "group": "SERVICE",
      "summary": "Records and condition review for acquisitions.",
      "modules": [
        "operate",
        "vault"
      ],
      "roles": [
        "director-of-maintenance",
        "fleet-manager"
      ],
      "orgTypes": [
        "part-91-owner",
        "corporate-flight-dept",
        "part-135"
      ],
      "pricingId": "ext-prebuy",
      "pricingDisposition": "STARTING_AT"
    },
    {
      "id": "a025-readiness",
      "name": "A025 Readiness & Implementation",
      "group": "SERVICE",
      "summary": "Readiness package for electronic recordkeeping/signature authorization.",
      "modules": [
        "operate"
      ],
      "roles": [
        "director-of-maintenance",
        "compliance-manager"
      ],
      "orgTypes": [
        "part-135",
        "fractional"
      ],
      "pricingId": "ext-a025-readiness",
      "pricingDisposition": "STARTING_AT"
    },
    {
      "id": "esign-readiness",
      "name": "Electronic-Signoff Readiness",
      "group": "SERVICE",
      "summary": "Align e-signoff with your RSM/QCM and authorizations.",
      "modules": [
        "shop"
      ],
      "roles": [
        "quality-manager",
        "accountable-manager"
      ],
      "orgTypes": [
        "part-145",
        "integrated-135-145"
      ],
      "pricingId": "ext-esign-readiness",
      "pricingDisposition": "CONTACT_US"
    },
    {
      "id": "wearable-inspection",
      "name": "Wearable Inspection & Evidence Capture",
      "group": "SERVICE",
      "summary": "Hands-free inspection evidence capture.",
      "modules": [
        "shop",
        "operate"
      ],
      "roles": [
        "inspector",
        "technician"
      ],
      "orgTypes": [
        "part-145",
        "mobile-aog"
      ],
      "pricingId": "ext-wearable-inspection",
      "pricingDisposition": "CONTACT_US"
    },
    {
      "id": "premium-support",
      "name": "Premium Support",
      "group": "SERVICE",
      "summary": "Enhanced support and SLA.",
      "modules": [
        "operate",
        "shop"
      ],
      "roles": [
        "accountable-manager",
        "director-of-maintenance"
      ],
      "orgTypes": [
        "part-135",
        "part-145"
      ],
      "pricingId": "ext-premium-support",
      "pricingDisposition": "STARTING_AT"
    }
  ]
}